function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from "prop-types";
import { Widget, WidgetHeader, WidgetTitle, WidgetDescription, WidgetBody, WidgetFooter, WidgetLoading } from "../";
import { Chart } from "../";
import { getGaChartByType } from "../../resources/functions/";
import "./AnalyticsChart.scss";

class AnalyticsChart extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      id: undefined,
      chart: undefined,
      loading: true,
      values: {}
    });

    _defineProperty(this, "componentDidUpdate", (prevProps, prevState) => {
      if (prevProps.report !== this.props.report) {
        this.getReport();
      }
    });

    _defineProperty(this, "getReport", () => {
      const _this$props = this.props,
            report = _this$props.report,
            type = _this$props.type,
            compare = _this$props.compare,
            stacked = _this$props.stacked,
            tooltipTitle = _this$props.tooltipTitle,
            tooltipLabel = _this$props.tooltipLabel;
      this.setState({
        chart: undefined,
        loading: true
      });

      if (!report) {
        return false;
      } // chart


      let chart;

      if (report) {
        chart = getGaChartByType(type, report);
      }

      this.setState({
        loading: false,
        chart: _extends({}, chart, {
          type: type,
          compare: compare,
          stacked: stacked,
          tooltipTitle: tooltipTitle,
          tooltipLabel: tooltipLabel
        })
      });
    });

    _defineProperty(this, "renderChart", () => {
      const _this$props2 = this.props,
            data = _this$props2.data,
            theme = _this$props2.theme,
            colors = _this$props2.colors;
      const chart = this.state.chart;
      return React.createElement(Chart, _extends({}, chart, {
        outerMargin: {
          top: 20,
          right: 20,
          bottom: 20,
          left: 20
        },
        theme: theme,
        colors: colors
      }));
    });
  }

  componentDidMount() {
    this.getReport();
  }

  render() {
    const _this$props3 = this.props,
          data = _this$props3.data,
          theme = _this$props3.theme,
          scope = _this$props3.scope,
          title = _this$props3.title,
          description = _this$props3.description,
          loadingTitle = _this$props3.loadingTitle;
    const _this$state = this.state,
          chart = _this$state.chart,
          values = _this$state.values;
    const loading = this.state.loading || this.props.loading;

    if (loading) {
      return React.createElement(Widget, this.props, React.createElement(WidgetLoading, {
        theme: theme,
        title: loadingTitle
      }));
    }

    return React.createElement(Widget, this.props, React.createElement(WidgetHeader, null, React.createElement(WidgetTitle, {
      title: title
    }), React.createElement(WidgetDescription, {
      description: description
    })), React.createElement(WidgetBody, null, this.renderChart()));
  }

}

_defineProperty(AnalyticsChart, "defaultProps", {
  loadingTitle: "Loading chart",
  scope: undefined,
  widgetType: "analytics-chart",
  widgetSize: "1:4",
  report: undefined,
  title: "Chart",
  type: "bar",
  compare: false,
  stacked: false,
  labels: undefined,
  debug: false
});

AnalyticsChart.propTypes = process.env.NODE_ENV !== "production" ? {
  loadingTitle: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  tooltipTitle: PropTypes.string,
  tooltipLabel: PropTypes.string,
  scope: PropTypes.string
} : {};
export default AnalyticsChart;